import { Card, CardContent } from './ui/card';
import { cn } from '../lib/utils';
import { Lock } from 'lucide-react';

interface SeatCardProps {
    seat: any;
    shifts: any[];
    bookings: any[];
    onSlotClick: (seat: any, shift: any, booking?: any) => void;
}

export function SeatCard({ seat, shifts, bookings, onSlotClick }: SeatCardProps) {
    // Filter bookings for this seat
    const seatBookings = bookings.filter(b => b.seat_id === seat.id);

    return (
        <Card className="mb-4 overflow-hidden border-0 shadow-sm bg-white/50 backdrop-blur-sm">
            <CardContent className="p-4 flex items-center justify-between">
                <div className="text-2xl font-bold text-foreground w-16">
                    {seat.seat_number}
                </div>
                <div className="flex-1 flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
                    {shifts.map(shift => {
                        // Check for any booking that overlaps with this shift
                        const conflictingBooking = seatBookings.find(b => {
                            const bookedShift = shifts.find(s => s.id === b.shift_id);
                            if (!bookedShift) return b.shift_id === shift.id; // Fallback if shift not found

                            // Check overlap: startA < endB && endA > startB
                            return shift.start_minute < bookedShift.end_minute && shift.end_minute > bookedShift.start_minute;
                        });

                        const isBooked = !!conflictingBooking;

                        return (
                            <div
                                key={shift.id}
                                onClick={() => onSlotClick(seat, shift, conflictingBooking)}
                                className={cn(
                                    "flex-1 min-w-[80px] p-2 rounded-lg text-xs font-medium cursor-pointer transition-all border",
                                    isBooked
                                        ? "bg-red-100 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-300 dark:border-red-900/50"
                                        : "bg-green-100 text-green-700 border-green-200 hover:bg-green-200 dark:bg-green-900/20 dark:text-green-300 dark:border-green-900/50"
                                )}
                            >
                                <div className="flex items-center justify-between mb-1">
                                    <span className="opacity-80">{shift.name}</span>
                                    {isBooked && <Lock className="h-3 w-3 opacity-50" />}
                                </div>
                                <div className="truncate font-semibold">
                                    {isBooked ? conflictingBooking?.user_name : "Free"}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </CardContent>
        </Card>
    );
}
